<template>
  <v-slide-x-reverse-transition
    group
    tag="div"
    style="display: block; position: fixed; top: 16px; right: 16px; width: 300px; z-index: 202;"
  >
    <v-alert
      v-for="snackbar in snackbars"
      v-bind:key="snackbar.id"
      dark
      prominent
      dismissible
      border="left"
      transition="scale-transition"
      class="py-3"
      :color="snackbar.type"
      :value="true"
      @input="closeSnackbar(snackbar.id)"
    >
      <v-icon slot="prepend" class="display-1 mr-2">{{ calcIcon(snackbar.type) }}</v-icon>
      <v-row no-gutters>
        <v-col cols="12" class="body-1" style="line-height: 1;">{{ snackbar.message }}</v-col>
        <v-col v-if="snackbar.desc" cols="12"></v-col>
        <v-col v-if="snackbar.desc" cols="12" class="body-2" style="word-break: break-all;">{{ snackbar.desc }}</v-col>
      </v-row>
    </v-alert>
  </v-slide-x-reverse-transition>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'snackbar',
    computed: {
      ...mapState({
        snackbars: state => state.snackbars
      })
    },
    methods: {
      calcIcon (type) {
        switch (type) {
          case 'error':
            return 'mdi-comment-remove'
          case 'warning':
            return 'mdi-comment-alert'
          case 'info':
            return 'mdi-comment-processing'
          case 'success':
            return 'mdi-comment-check'
          default:
            return 'mdi-comment'
        }
      },
      closeSnackbar (id) {
        this.$store.commit('removeSnackbar', id)
      }
    }
  }
</script>
